const mutations = {

  getPxReport: (state, pxreport) => {
    state.pxreport = pxreport;
  },

};

export default mutations;
